import React from "react";
import { Image, Shimmer } from "react-shimmer";

import { PreviewQuestionCard } from "@modules/shared/components/";

const Component = (props: any) => {
    const { hw, onDownload = () => null } = props;

    function getContent() {
        return (
            <div>
                <div className={"p-4 flex flex-row align-middle"}>
                    <img
                        src="/assets/images/tha.png"
                        style={{ width: "48px" }}
                        className={"mx-3"}
                    />
                    <div className="text-2xl font-black leading-5 px-1">
                        The Homework
                        <br />
                        App
                    </div>
                </div>
                <div className={"pad-16"}>
                    <div style={{ padding: "0px 8px" }}>
                        <div className={"preview-type"}>{hw?.type}</div>
                        <div className={"preview-title"}>{hw?.title}</div>
                    </div>
                    <div className={"height-30"} />

                    {hw?.questions_with_type?.map(
                        (question: any, idx: number) => (
                            <div>
                                {question.type === "IMAGE" ? (
                                    <Image
                                        NativeImgProps={{ width: "100%" }}
                                        src={question.image}
                                        alt="concept_image"
                                        fallback={
                                            <Shimmer
                                                width={"100%"}
                                                height={"75vh"}
                                            />
                                        }
                                    />
                                ) : question.type === "TEXT" ? (
                                    <div className="worksheet-homework-text">
                                        {question.text}
                                    </div>
                                ) : question.type === "SUBJECTIVE" ? (
                                    <PreviewQuestionCard
                                        idx={question.index + 1}
                                        tags={question.question_data.tags}
                                        questionText={
                                            question.question_data.text
                                        }
                                        options={question.question_data.options}
                                    />
                                ) : question.type === "CASE_STUDY" ? (
                                    <PreviewQuestionCard
                                        idx={question.index + 1}
                                        tags={question.question_data.tags}
                                        questionText={
                                            question.question_data.text
                                        }
                                        subQuestions={question.sub_questions}
                                    />
                                ) : question.type === "MCQ" ? (
                                    <PreviewQuestionCard
                                        idx={question.index + 1}
                                        tags={question.question_data.tags}
                                        questionText={
                                            question.question_data.text
                                        }
                                        options={question.question_data.options}
                                    />
                                ) : (
                                    <></>
                                )}
                            </div>
                        ),
                    )}
                </div>
            </div>
        );
    }

    function getFooter() {
        return (
            <div
                className="flex flex-row items-center w-full h-full bg-white justify-around px-4 py-3 cursor-pointer"
                style={{ boxShadow: "2px 2px 16px rgba(0, 0, 0, 0.16)" }}
                onClick={onDownload}
            >
                <div
                    className={"text-center font-light text-sm leading-4"}
                    style={{ color: "#270F36" }}
                >
                    Get access to 10k+ ready-made
                    <br />
                    worksheets on the app
                </div>
                <div
                    className={
                        "w-fit h-12 flex justify-center items-center px-6 py-4 rounded-lg font-bold text-sm leading-4"
                    }
                    style={{
                        backgroundColor: "#270F36",
                        color: "white",
                        // width: "170px",
                    }}
                >
                    Download now!
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* mobile */}
            <div className={"block md:hidden"}>
                <div className="fixed w-full bottom-0">{getFooter()}</div>
                {getContent()}
                <br />
                <br />
                <br />
            </div>

            {/* desktop */}
            <div className={"hidden md:block"}>
                <div
                    className="overflow-y-auto overflow-x-hidden"
                    style={{ height: "90vh" }}
                >
                    {getContent()}
                </div>
                <div style={{ height: "10vh", overflow: "auto" }}>
                    {getFooter()}
                </div>
            </div>
        </div>
    );
};

export default Component;
